import Service 				from "./../../Libs/Service";
import _ 					from "lodash";

import { FileZip } 			from "./File.Zip";
import { Auth } 			from "./Auth";
import SetupSettings 		from "./../settings/settings.json";

// Клиентский сервис файлового менеджера. Общается с сервером через socket экшены
// (список, создание, переименование, удаление, копирование, перенос, права, публичные ссылки)
// и через http (загрузка / скачивание файлов).
let FileService = new Service({

	Name: "File",

	Events: {

		//Переключение рабочей ноды: активные карты данных подменяются картами этой ноды
		"Cluster Working Node Changed": function(previousServerId, serverId) {

			this.useServer(serverId);

		}

	},

	Actions: {

		// Полное состояние файлового менеджера (открытая папка + статистика хранилища)
		// serverId - нода, с которой пришли данные
		"File": function(state, data, size, serverId) {

			this.setState(state, serverId);

		},

		// Список публичных ссылок паблишера
		"FileLinks": function(state, data, size, serverId) {

			this.setLinks(state, serverId);

		},

		// Список предыдущих версий файла
		"FileVersions": function(state, data, size, serverId) {

			this.setVersions(state, serverId);

		},

		// Результаты поиска по файлам и папкам раздела
		"FileSearch": function(state) {

			Broadcast.call("File Search Changed", [state]);

		},

		// Результат операции: {operation, error, ...}
		"FileResult": function(result) {

			this.Result = result;

			Broadcast.call("File Result", [result]);

		},

		// Ответ на ввод ключа шифрования раздела Documents
		"DocumentKeyResult": function(result) {

			Broadcast.call("Document Key Result", [result]);

		}

	},

	init() {

		// Карты данных по нодам кластера: у каждой ноды своя БД, и id паблишеров и пути файлов
		// на разных нодах совпадают, поэтому карты разделены по нодам (Client/Libs/Service.js, getServerMap)
		this.StatesByServer = {};
		this.LinksByPublisherByServer = {};
		this.VersionsByServer = {};

		// Активные карты - карты рабочей ноды
		this.useServer(0);

		// Предыдущую версию сохраняем только для файлов не больше 100 МБ и храним максимум 3 версии
		this.FILE_VERSION_SIZE_LIMIT = 100 * 1024 * 1024;
		this.FILE_VERSION_MAX_COUNT = 3;

		this.Result = null;

		// Максимальный размер папки без сжатия, которую можно загрузить одним zip-архивом
		this.FOLDER_UPLOAD_SIZE_LIMIT = 100 * 1024 * 1024;

		// Максимальный размер папки без сжатия, которую можно скачать одним zip-архивом
		this.FOLDER_DOWNLOAD_SIZE_LIMIT = 100 * 1024 * 1024;

	},

	// Активные карты данных рабочей ноды: при переключении ноды они подменяются ссылками на карты
	// этой ноды, поэтому код обращения к ним (States[getKey(...)]) не меняется
	useServer(serverId) {

		serverId = serverId || 0;

		if (this.NodeServerId === serverId) return;

		this.NodeServerId = serverId;

		this.States = this.getServerMap(this.StatesByServer, serverId);
		this.LinksByPublisher = this.getServerMap(this.LinksByPublisherByServer, serverId);
		this.Versions = this.getServerMap(this.VersionsByServer, serverId);

	},

	// Ключ кэша файлов: id паблишера + путь (файлы разных нод лежат в разных картах)
	getKey(publisherId, path) {

		return `${publisherId}:${path || ""}`;

	},

	setState(state, serverId) {

		if (!state) return;

		serverId = serverId || this.NodeServerId;

		let key = this.getKey(state.publisherId, state.path);

		this.getServerMap(this.StatesByServer, serverId)[key] = state;

		_.each(state.entries, entry => entry.date = new Date(entry.date));

		Broadcast.call("File Changed", [state]);

	},

	// Сохраняем список публичных ссылок паблишера и оповещаем интерфейс
	setLinks(state, serverId) {

		if (!state) return;

		serverId = serverId || this.NodeServerId;

		_.each(state.links, link => {
			link.createDate = new Date(link.date);
			// Помечаем ссылки защищённого раздела, чтобы открывать их по адресу /document-link/*
			link.section = state.section || "files";
		});

		this.getServerMap(this.LinksByPublisherByServer, serverId)[state.publisherId] = state.links;

		Broadcast.call("File Links Changed", [state]);

	},

	getLinks(publisherId) {

		return this.LinksByPublisher[publisherId] || [];

	},

	// Сохраняем список предыдущих версий файла и оповещаем интерфейс
	setVersions(state, serverId) {

		if (!state) return;

		serverId = serverId || this.NodeServerId;

		// Версии приходят от сервера уже отсортированными: сначала самые новые
		let key = this.getKey(state.publisherId, state.path);

		this.getServerMap(this.VersionsByServer, serverId)[key] = state.versions || [];

		Broadcast.call("File Versions Changed", [state]);

	},

	getVersions(publisherId, path) {

		return this.Versions[this.getKey(publisherId, path)] || [];

	},

	getState(publisherId, path) {

		return this.States[this.getKey(publisherId, path)] || null;

	},

	clearPublisherStates(publisherId) {

		_.each(_.keys(this.States), key => {

			if (key.indexOf(`${publisherId}:`) === 0) delete this.States[key];

		});

	},

	// Пользователи паблишера берём из общего клиентского стора (Client/App/services/User.js)
	getPublisherUsers(publisherId) {

		return User.getUsersByPublisher(publisherId);

	},

	// Раздел Documents использует publisherId = 0: у него свои экшены (Document*) и роуты (/documents/*)
	isDocuments(publisherId) {

		return publisherId === 0;

	},

	// Имя экшена: обычный раздел Files или защищённый раздел Documents
	actionName(publisherId, filesAction, documentsAction) {

		return this.isDocuments(publisherId) ? documentsAction : filesAction;

	},

	// Данные экшена: в разделе Documents нет паблишера, поэтому publisherId в запрос не добавляем
	// (иначе серверная проверка доступа отклонит лишний параметр)
	actionData(publisherId, data) {

		return this.isDocuments(publisherId) ? _.extend({}, data) : _.extend({publisherId}, data);

	},

	// Запрашиваем у сервера содержимое папки
	request(publisherId, path = "") {

		Server.sendToServer({
			[this.actionName(publisherId, "FileGet", "DocumentGet")]: this.actionData(publisherId, {path: path || ""})
		});

	},

	// Запрашиваем у сервера поиск по имени среди всех файлов и папок раздела
	search(publisherId, query) {

		Server.sendToServer({
			[this.actionName(publisherId, "FileSearch", "DocumentSearch")]: this.actionData(publisherId, {query: query || ""})
		});

	},

	createFolder(publisherId, path, name) {

		Server.sendToServer({[this.actionName(publisherId, "FileCreateFolder", "DocumentCreateFolder")]: this.actionData(publisherId, {path: path || "", name})});

	},

	rename(publisherId, path, name) {

		Server.sendToServer({[this.actionName(publisherId, "FileRename", "DocumentRename")]: this.actionData(publisherId, {path, name})});

	},

	remove(publisherId, path) {

		Server.sendToServer({[this.actionName(publisherId, "FileDelete", "DocumentDelete")]: this.actionData(publisherId, {path})});

	},

	copy(publisherId, sourcePath, targetPath) {

		Server.sendToServer({[this.actionName(publisherId, "FileCopy", "DocumentCopy")]: this.actionData(publisherId, {sourcePath, targetPath})});

	},

	move(publisherId, sourcePath, targetPath) {

		Server.sendToServer({[this.actionName(publisherId, "FileMove", "DocumentMove")]: this.actionData(publisherId, {sourcePath, targetPath})});

	},

	setPermissions(publisherId, path, userIds) {

		Server.sendToServer({[this.actionName(publisherId, "FileSetPermissions", "DocumentSetPermissions")]: this.actionData(publisherId, {path, userIds: userIds || []})});

	},

	setStorageSize(publisherId, size) {

		Server.sendToServer({FileSetStorageSize: {publisherId, size}});

	},

	// Ссылка для скачивания файла (токен добавляем в url, так как браузер открывает ссылку сам)
	getDownloadUrl(publisherId, path) {

		let base = `${location.protocol}//${SetupSettings["domain"]}`;

		if (this.isDocuments(publisherId)) return Auth.addTokenToUrl(`${base}/documents/download?path=${encodeURIComponent(path)}`);

		return Auth.addTokenToUrl(`${base}/file/download?publisherId=${publisherId}&path=${encodeURIComponent(path)}`);

	},

	// Ссылка для просмотра файла на странице (например картинка)
	getRawUrl(publisherId, path) {

		let base = `${location.protocol}//${SetupSettings["domain"]}`;

		if (this.isDocuments(publisherId)) return Auth.addTokenToUrl(`${base}/documents/raw?path=${encodeURIComponent(path)}`);

		return Auth.addTokenToUrl(`${base}/file/raw?publisherId=${publisherId}&path=${encodeURIComponent(path)}`);

	},

	download(publisherId, path) {

		// Скачиваем через скрытую ссылку, а не через window.location.href:
		// переход по адресу заменял бы дашборд целиком, если ответ не файл.
		let link = document.createElement('a');

		link.href = this.getDownloadUrl(publisherId, path);
		link.download = (path || '').split('/').pop() || 'file';

		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);

	},

	// Ссылка для скачивания папки одним zip-архивом
	getDownloadFolderUrl(publisherId, path) {

		let base = `${location.protocol}//${SetupSettings["domain"]}`;

		if (this.isDocuments(publisherId)) return Auth.addTokenToUrl(`${base}/documents/download-folder?path=${encodeURIComponent(path)}`);

		return Auth.addTokenToUrl(`${base}/file/download-folder?publisherId=${publisherId}&path=${encodeURIComponent(path)}`);

	},

	// Скачиваем папку одним zip-архивом (сервер упаковывает её перед отдачей)
	downloadFolder(publisherId, path) {

		// Как и для файла, скачиваем через скрытую ссылку, чтобы не заменить дашборд целиком.
		let link = document.createElement('a');

		link.href = this.getDownloadFolderUrl(publisherId, path);
		link.download = ((path || '').split('/').pop() || 'folder') + '.zip';

		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);

	},

	// Загрузка файлов (список File из input) в папку паблишера или в раздел Documents
	upload(publisherId, path, fileList, onProgress, onDone) {

		let formData = new FormData();

		if (!this.isDocuments(publisherId)) formData.append("publisherId", publisherId);
		formData.append("path", path || "");

		_.each(fileList, (file, index) => formData.append(`file-${index}`, file, file.name));

		let url = `${location.protocol}//${SetupSettings["domain"]}${this.isDocuments(publisherId) ? "/documents/upload" : "/file/upload"}`;

		let xhr = new XMLHttpRequest();

		xhr.open("POST", url);

		Auth.authorizeRequest(xhr);

		xhr.upload.onprogress = e => {

			if (e.lengthComputable && onProgress) onProgress(e.loaded / e.total);

		};

		xhr.onload = () => {

			let result = null;

			try {

				result = JSON.parse(xhr.responseText);

			} catch (e) {

				result = {error: xhr.responseText};

			}

			if (onDone) onDone(xhr.status === 200 ? null : (result?.error || "Upload failed"), result);

		};

		xhr.onerror = () => {

			if (onDone) onDone("Upload failed", null);

		};

		xhr.send(formData);

	},

	// ---- Предыдущие версии файлов ----

	// Запрашиваем список сохранённых версий файла
	requestVersions(publisherId, path) {

		Server.sendToServer({[this.actionName(publisherId, "FileVersionsGet", "DocumentVersionsGet")]: this.actionData(publisherId, {path: path || ""})});

	},

	// Восстанавливаем предыдущую версию: она и текущий файл меняются местами
	restoreVersion(publisherId, path, versionId) {

		Server.sendToServer({[this.actionName(publisherId, "FileRestoreVersion", "DocumentRestoreVersion")]: this.actionData(publisherId, {path, versionId: String(versionId)})});

	},

	// Сохраняем отредактированный текстовый файл (редактирование через textarea)
	writeFile(publisherId, path, content, onDone) {

		let formData = new FormData();

		if (!this.isDocuments(publisherId)) formData.append("publisherId", publisherId);
		formData.append("path", path || "");
		formData.append("content", content == null ? "" : content);

		let xhr = new XMLHttpRequest();

		xhr.open("POST", `${location.protocol}//${SetupSettings["domain"]}${this.isDocuments(publisherId) ? "/documents/write" : "/file/write"}`);

		Auth.authorizeRequest(xhr);

		xhr.onload = () => {

			let result = null;

			try {

				result = JSON.parse(xhr.responseText);

			} catch (e) {

				result = {error: xhr.responseText};

			}

			if (onDone) onDone(xhr.status === 200 ? null : (result?.error || "Save failed"), result);

		};

		xhr.onerror = () => {

			if (onDone) onDone("Save failed", null);

		};

		xhr.send(formData);

	},

	// Читаем текст файла (для просмотра и редактирования)
	async readText(publisherId, path) {

		let response = await fetch(this.getRawUrl(publisherId, path));

		if (!response.ok) throw new Error((await response.text()) || "Failed to read file");

		return response.text();

	},

	// Читаем бинарное содержимое файла (нужно для просмотра docx и таблиц xlsx)
	async readBuffer(publisherId, path) {

		let response = await fetch(this.getRawUrl(publisherId, path));

		if (!response.ok) throw new Error((await response.text()) || "Failed to read file");

		return response.arrayBuffer();

	},

	// Как показывать файл в просмотрщике: image / video / audio / pdf / html / docx / xlsx / text / null
	getPreviewKind(path) {

		let extension = this.getExtension(path);

		if (_.includes(["png", "jpg", "jpeg", "gif", "webp", "bmp", "svg", "ico", "avif"], extension)) return "image";
		if (_.includes(["mp4", "webm", "ogv", "mov", "m4v"], extension)) return "video";
		if (_.includes(["mp3", "wav", "ogg", "oga", "m4a", "aac", "flac"], extension)) return "audio";
		if (extension === "pdf") return "pdf";
		if (_.includes(["html", "htm"], extension)) return "html";
		if (extension === "docx") return "docx";
		if (_.includes(["xlsx", "xlsm", "xlsb", "xls"], extension)) return "xlsx";
		if (this.isTextFile(path)) return "text";

		return null;

	},

	// Текстовый ли файл - такие файлы показываем текстом и даём редактировать
	isTextFile(path) {

		return _.includes([
			"txt", "md", "json", "js", "mjs", "cjs", "ts", "jsx", "tsx", "vue", "css", "scss", "sass", "less",
			"xml", "csv", "log", "yml", "yaml", "ini", "conf", "sh", "bat", "sql", "env", "gitignore"
		], this.getExtension(path));

	},

	// Расширение файла в нижнем регистре ('a/b/File.TXT' -> 'txt')
	getExtension(path) {

		let name = String(path || "").split("/").pop() || "";
		let index = name.lastIndexOf(".");

		return index === -1 ? "" : name.substring(index + 1).toLowerCase();

	},

	// ---- Публичные ссылки ----

	// Запрашиваем список публичных ссылок паблишера или раздела Documents
	requestLinks(publisherId) {

		Server.sendToServer({[this.actionName(publisherId, "FileLinksGet", "DocumentLinksGet")]: this.actionData(publisherId, {})});

	},

	// Создаём публичную ссылку на папку или файл
	createLink(publisherId, path) {

		Server.sendToServer({[this.actionName(publisherId, "FileLinkCreate", "DocumentLinkCreate")]: this.actionData(publisherId, {path: path || ""})});

	},

	// Удаляем публичную ссылку
	deleteLink(publisherId, linkId) {

		Server.sendToServer({[this.actionName(publisherId, "FileLinkDelete", "DocumentLinkDelete")]: this.actionData(publisherId, {linkId})});

	},

	// Публичный адрес ссылки (открывается без авторизации)
	getLinkUrl(link) {

		if (!link) return "";

		// У защищённого раздела Documents своя публичная страница со ссылками /document-link/*
		if (link.section === "documents") return `${location.protocol}//${SetupSettings["domain"]}/document-link/${link.hash}`;

		return `${location.protocol}//${SetupSettings["domain"]}/file-link/${link.hash}`;

	},

	// ---- Загрузка папки zip-архивом ----

	// Загрузка папки: проверяем размер без сжатия, упаковываем в zip и шлём одним архивом
	async uploadFolder(publisherId, path, fileList, onProgress, onDone) {

		try {

			let files = _.values(fileList || []).filter(file => !!file);

			if (!files.length) throw new Error("Selected folder is empty");

			let totalSize = _.sumBy(files, file => file.size || 0);

			if (totalSize > this.FOLDER_UPLOAD_SIZE_LIMIT) {

				throw new Error(`Selected folder is ${FileZip.formatSize(totalSize)} without compression. Maximum is ${FileZip.formatSize(this.FOLDER_UPLOAD_SIZE_LIMIT)}`);

			}

			if (onProgress) onProgress(0);

			let entries = [];

			for (let i = 0; i < files.length; i++) {

				let file = files[i];
				let relativePath = file["webkitRelativePath"] || file.name;

				entries.push({name: relativePath, data: await this.readFileAsBytes(file)});

				if (onProgress) onProgress((i + 1) / files.length);

			}

			let folderName = (entries[0].name.split("/")[0] || "folder") + ".zip";
			let archive = new File([FileZip.create(entries)], folderName, {type: "application/zip"});

			this.uploadFolderArchive(publisherId, path, archive, onDone);

		} catch (e) {

			if (onDone) onDone(e?.message || String(e));

		}

	},

	// Читаем файл в Uint8Array (для упаковки в zip)
	readFileAsBytes(file) {

		return new Promise((resolve, reject) => {

			let reader = new FileReader();

			reader.onload = () => resolve(new Uint8Array(reader.result));
			reader.onerror = () => reject(reader.error || new Error("Failed to read file"));

			reader.readAsArrayBuffer(file);

		});

	},

	// Отправляем готовый zip-архив папки на сервер
	uploadFolderArchive(publisherId, path, archive, onDone) {

		let formData = new FormData();

		if (!this.isDocuments(publisherId)) formData.append("publisherId", publisherId);
		formData.append("path", path || "");
		formData.append("file", archive, archive.name);

		let xhr = new XMLHttpRequest();

		xhr.open("POST", `${location.protocol}//${SetupSettings["domain"]}${this.isDocuments(publisherId) ? "/documents/upload-folder" : "/file/upload-folder"}`);

		Auth.authorizeRequest(xhr);

		xhr.onload = () => {

			let result = null;

			try {

				result = JSON.parse(xhr.responseText);

			} catch (e) {

				result = {error: xhr.responseText};

			}

			if (onDone) onDone(xhr.status === 200 ? null : (result?.error || "Upload failed"), result);

		};

		xhr.onerror = () => {

			if (onDone) onDone("Upload failed", null);

		};

		xhr.send(formData);

	}

});

window.FileService = FileService;

export { FileService as File };
